import { CellularDeviceStatusPipe } from './cellular-device-status.pipe';
import { FormatAddressFilterPipe } from './format-address-filter.pipe';
import { FormatHardwareVersionPipe } from './format-hardware-version.pipe';
import { HighlightPipe } from './highlight.pipe';
import { MacAddressFilterPipe } from './mac-address-filter.pipe';
import { NgModule } from '@angular/core';
import { NullValuePipe } from './null-value.pipe';
import { MemoizePipe } from './memoize.pipe';

@NgModule({
    declarations: [
        CellularDeviceStatusPipe,
        FormatAddressFilterPipe,
        FormatHardwareVersionPipe,
        HighlightPipe,
        MacAddressFilterPipe,
        NullValuePipe,
        MemoizePipe,
    ],
    exports: [
        CellularDeviceStatusPipe,
        FormatAddressFilterPipe,
        FormatHardwareVersionPipe,
        HighlightPipe,
        MacAddressFilterPipe,
        NullValuePipe,
        MemoizePipe,
    ],
})
export class SharedPipesModule {}
